import { render, staticRenderFns } from "./SeatMenu.vue?vue&type=template&id=7f20f79a"
import script from "./SeatMenu.vue?vue&type=script&lang=js"
export * from "./SeatMenu.vue?vue&type=script&lang=js"
import style0 from "./SeatMenu.vue?vue&type=style&index=0&id=7f20f79a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports